

import React from 'react'
import './infoPage.css'
import './App.css'

import {
    Html,
    Body,
    Container,
    Text,
    Button,
    Img,
} from "@react-email/components";


export default function InfoPage() {


    return (
        <div className='App text'>
            <div className='infoPage'>
                <h1 className='main-info-header info'> Dette var et phishing forsøg! </h1>
                <h2 className='secondary-info-header info'> Men det var heldigvis kun en prøve... </h2>

                <Text className='info'> Undgå at fortælle andre om prøven, før dagen er ovre. </Text>

            </div>
        </div>
    )
}